import { type FinancialExtractionId, type SuretyAccountId } from "@inrev/common";

export const balanceSheetsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "balance-sheets"] as const;

export const financialExtractionsQueryKey = (
	accountId: SuretyAccountId,
	extractionId?: FinancialExtractionId,
) =>
	extractionId
		? (["accounts", accountId, "financial-extractions", extractionId] as const)
		: (["accounts", accountId, "financial-extractions"] as const);

export const financialPeriodsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "financial-periods"] as const;

export const incomeStatementsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "income-statements"] as const;
